import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import CypherHQ from './cypherHQ';
import CypherBusiness from './cypherBusiness';
import CypherCard from './card/cypherCard';
import ActivateCard from './card/activateCard';
import Redirect from './components/redirect';
import FAQ from './faq';
import TelegramAuth from './telegramAuth';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/'} element={<CypherHQ />} />
        <Route path={'/business'} element={<CypherBusiness />} />
        <Route path={'/card'} element={<CypherCard />} />
        <Route path={'/activatecard'} element={<ActivateCard />} />
        <Route path='/twitter' element={<Redirect />} />
        <Route path='/linkedin' element={<Redirect />} />
        <Route path='/discord' element={<Redirect />} />
        <Route path='/reddit' element={<Redirect />} />
        <Route path='/youtube' element={<Redirect />} />
        <Route path='/medium' element={<Redirect />} />
        <Route path={'/faq'} element={<FAQ />} />
        <Route path={'/telegram/auth'} element={<TelegramAuth />} />
        <Route path='*' element={<Navigate to={'/'} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
